import { ColumnSetting } from '../../../_foundation/models/grid.models';

export const columns: ColumnSetting[] = [
  {
    field: 'contractualConcurrentText',
    title: 'Type',
    filter: 'icon',
    width: 50,
    minWidth: 50
  },
  {
    field: 'operationClassification',
    title: 'Operation Classification',
    filter: 'text',
    width: 140
  },
  /*{
    field: 'operation.name',
    title: 'Operation',
    filter: 'text',
    width: 160
  },*/
  {
    field: 'lineTypeName',
    title: 'Line Type',
    filter: 'text',
    width: 120
  },
  {
    field: 'operationName',
    title: 'Operation / Step Name',
    filter: 'text',
    width: 180
  },
  {
    field: 'comment',
    title: 'Comment',
    filter: 'text',
    width: 180
  },
  {
    field: 'startTimeShow',
    title: 'Start',
    filter: 'text',
    width: 120,
    minWidth: 120
  },
  {
    field: 'startTimeConfirmed',
    title: '',
    filter: 'checkbox',
    width: 65,
    minWidth: 65
  },
  {
    field: 'endTimeShow',
    title: 'End',
    filter: 'text',
    width: 120,
    minWidth: 120
  },
  {
    field: 'endTimeConfirmed',
    title: '',
    filter: 'checkbox',
    width: 65,
    minWidth: 65
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 140,
    minWidth: 140,
  }
];



// WEBPACK FOOTER //
// ./src/pages/daily-log/daily-log-component/daily-log-component.config.ts